import { rosterAPI } from '@/providers/apis/roster/roster';
import { USERS_FILTERS } from '@/utils/roster';
import { Vue, Component, Prop } from 'vue-property-decorator';
import DateRangePicker from 'vue2-daterange-picker';
import moment from 'moment';
import { copy } from '@/utils/cohort';
import { adminUtilsAPI } from '@/providers/apis/admin-utils/admin-utils';
import { isAPICatchError, isEmptyValue } from '@/utils/utils';
import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';
@Component({
    name: 'classes-page',
    components: {
        'date-range-picker': DateRangePicker,
    },
})

export default class ClassesPage extends Vue {

    // -----------------------------------------------------------------------
    // Properties

    private fieldsItems: any[] = [
        {
            key: 'index',
            label: '',
            thClass: 'sticky-position text-center custom-alignment',
            tdClass: 'text-center index custom-alignment',
            allowFilter: false,
        },
        {
            key: 'title',
            label: 'Class Name',
            thClass: 'sticky-position custom-alignment',
            tdClass: 'custom-alignment title',
            sortable: true,
            allowFilter: true,
        },
        {
            key: 'schoolName',
            label: 'School Name',
            thClass: 'sticky-position custom-alignment',
            tdClass: 'custom-alignment',
            sortable: true,
            allowFilter: true,
        },
        {
            key: 'code',
            label: 'Code',
            thClass: 'sticky-position custom-alignment',
            tdClass: 'code custom-alignment',
            sortable: true,
            allowFilter: true,
        },
        {
            key: 'referenceId',
            label: 'Sourced Id',
            thClass: 'sticky-position custom-alignment',
            tdClass: 'reference-id custom-alignment',
            sortable: true,
            allowFilter: true,
        },
        {
            key: 'updatedAt',
            label: 'Last Updated',
            thClass: 'sticky-position custom-alignment last-Updated',
            tdClass: 'last-Updated custom-alignment',
            sortable: true,
            allowFilter: true,
        },
        {
            key: 'studentCount',
            label: 'Students Count',
            thClass: 'sticky-position custom-alignment stud-count',
            tdClass: 'stud-count text-center custom-alignment',
            sortable: true,
            allowFilter: false,
        },
        {
            key: 'teacherCount',
            label: 'Teachers Count',
            thClass: 'sticky-position stud-count custom-alignment',
            tdClass: 'text-center stud-count custom-alignment',
            sortable: true,
            allowFilter: false,
        },
        {
            key: 'action',
            label: 'Action',
            thClass: 'sticky-position text-center custom-alignment action',
            tdClass: 'action custom-alignment',
            // sortable: false,
            allowFilter: false,
            stickyColumn: true,
        },
    ];

    private filterList: any = [
        {
            key: 'teacherCount',
            label: 'Teachers Count',
            thClass: 'sticky-position',
            tdClass: '',
            sortable: true,
            allowFilter: false,
        },
    ];
    private listItemData: any = {};
    private isVisibleEditClass: boolean = false;
    private isDisableButton: boolean = true;
    private editClassGetId = '';
    private enableWidgetsSwitch: boolean = false;
    private searchTerms: any = {};

    private classesList: any = [];

    private perPage: number = 10;

    private totalRowCounts: number = 0;

    private limit: number = 10;

    private offset: number = 0;

    private currentPage: number = 1;

    private isLoading: boolean = false;

    private searchItem: any = {
        searchTxt: '',
        dateRange: '',
        grade: '',
        class: '',
        school: '',
    };

    private isDisplayPagination: boolean = false;

    private selectedArchiveList: any = [];

    private selectedArchive: any = [];

    private isShowDateFilter: boolean = false;

    private isSelectAll: boolean = false;

    private isArchiveSuccessfully: boolean = false;

    private selectedFilterItem: any = ['index', 'title', 'code',
        'sourceid', 'studentCount', , 'schoolName', 'updatedAt', 'teacherCount',
        'action'];

    @Prop({ default: null })
    private schoolData: any;

    private get isArchiveList() {
        return this.selectedArchive.length > 0;
    }

    private get isSelectedCheckBox() {
        let showBox = false;
        for (const listItem of this.classesList) {
            const selectedIndex = this.selectedArchiveList.findIndex((item: any) => item.id === listItem.id);
            if (selectedIndex !== -1) {
                showBox = true;
                break;
            }
        }
        return showBox;
    }

    private get isAllSelectedCheckBox() {
        const selectedArray = [];
        for (const listItem of this.classesList) {
            const selectedIndex = this.selectedArchiveList.findIndex((item: any) => item.id === listItem.id);
            if (selectedIndex !== -1) {
                selectedArray.push(listItem);
            }
        }
        this.isSelectAll = true;
        return this.classesList.length === selectedArray.length;
    }

    public get filteredClassItemList() {
        return this.fieldsItems.filter((item: any) => {
            return this.selectedFilterItem.includes(item.key);
        });
    }

    private dateRange: any = {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: new Date(),
    };

    private isSearched: any = false;

    private archiveListModal: any = [];

    // -----------------------------------------------------------------------
    // Actions

    public onSearch() {
        this.resetProperties();
        this.getClassList();
    }

    public onSelectPage(pageNumber: number) {
        this.classesList = [];
        this.currentPage = pageNumber;
        this.offset = (pageNumber - 1) * this.limit;
        this.getClassList();
    }

    public onSelectRow(row: any) {
        row.routePath = this.$route.path;
        this.$emit('onSelectRow', row, 'classData');
        this.$router.push('/users-rosters/users');
    }

    public onGoBack() {
        this.$emit('onSelectRow', null, 'schoolData');
        this.$router.push('/users-rosters/schools');
    }

    // -----------------------------------------------------------------------
    // Hooks

    private created() {
        this.isDisplayPagination = false;
        this.getTenantSettings();
        this.getClassList();
        if (this.schoolData) {
            const schoolColumn = this.fieldsItems.find((item) => item.key === 'schoolName');
            if (schoolColumn) {
                schoolColumn.thClass = 'd-none';
                schoolColumn.tdClass = 'd-none';
            }
        }
    }

    // ------------------------------------------------------------------------
    // Methods
private getTenantSettings() {
tenantSettingsAPI.fetchActiveTenantSettings().then((settingsData: any) => {
    if (settingsData.ui_element_visibility_settings.enable_navigator_generative_ai_widget === 'on' ) {
        this.isVisibleEditClass = true;
    } else {
        this.isVisibleEditClass = false;
    }

});
}
private enableWidgetSwitch() {
    const checkDisable = this.listItemData.setting['enable.mygooru.widget']
                         ? this.listItemData.setting['enable.mygooru.widget'] : false;
    if ( checkDisable === this.enableWidgetsSwitch) {
        this.isDisableButton = true;
    } else {
        this.isDisableButton = false;
    }

}
    private onEditClass(listItem: any) {
        this.$bvModal.show('edit-classes');
        this.listItemData = listItem;
        this.editClassGetId = listItem.id;
        this.enableWidgetsSwitch = listItem.setting['enable.mygooru.widget']
                                     ? listItem.setting['enable.mygooru.widget'] : false;
        this.enableWidgetSwitch();
    }
    private hideEditUserModal() {
        this.$bvModal.hide('edit-classes');
    }
    private onSaveEnableWidget() {
        this.hideEditUserModal();
        this.isLoading = true;
        const data = {
            setting: {
                 'enable.mygooru.widget': this.enableWidgetsSwitch,
             },
         };
        rosterAPI.getEditClasses(this.editClassGetId, data).then((response) => {
            if (response) {
                this.getClassList();
            }
        });
    }

    private getClassList() {
        this.isLoading = true;
        const offset = this.offset;
        const limit = this.limit;
        const searchTerms = this.searchTerms;
        const schoolData = this.schoolData;
        const params: any = {
            offset,
            limit,
        };
        for (const key in searchTerms) {
            if (Object.prototype.hasOwnProperty.call(searchTerms, key)) {
                const element = searchTerms[key];
                if (!isEmptyValue(element)) {
                    params[key] = element;
                }
            }
        }
        if (schoolData) {
            params.parent_id = schoolData.id;
        }
        rosterAPI.getClassesDetails(params).then((data: any) => {
            this.isLoading = false;
            this.classesList = data.classes || [];
            this.totalRowCounts = data.totalCounts || 0;
            if (data.totalCounts > 0) {
                this.isDisplayPagination = true;
            }
        });
    }

    private resetProperties() {
        this.classesList = [];
        this.limit = 10;
        this.offset = 0;
        this.currentPage = 1;
    }

    private onSelectArchive(listItem: any) {
        const selectedIndex = this.selectedArchiveList.findIndex((item: any) => item.id === listItem.id);
        if (selectedIndex === -1) {
            this.selectedArchiveList.push(listItem);
        } else {
            this.selectedArchiveList.splice(selectedIndex, 1);
        }
        this.selectedArchive = this.selectedArchiveList.map((items: any) => {
            return items.id;
        });
    }

    private showDateFilter() {
        this.isShowDateFilter = true;
        setTimeout(() => {
            const datePick: any = this.$refs.picker as HTMLElement;
            if (datePick) {
                datePick[0].togglePicker(true);
            }
        }, 200);
    }

    private updateValues() {
        this.offset = 0;
        const dataRange = copy(this.dateRange);
        this.searchTerms.modified_at = `${moment(dataRange.startDate).format('YYYY-MM-DD')}`;
        this.onSearch();
    }

    private onSelectFilter(item: any) {
        const filterIndex = this.selectedFilterItem.findIndex((filterItem: any) => filterItem === item.key);
        if (filterIndex === -1) {
            this.selectedFilterItem.push(item.key);
        } else {
            this.selectedFilterItem.splice(filterIndex, 1);
        }
    }

    private removeDateFilter() {
        this.isShowDateFilter = false;
        this.dateRange = {
            startDate: moment().format('YYYY-MM-DD'),
            endDate: new Date(),
        };
        this.searchTerms.modified_at = '';
        this.onSearch();
        // this.searchItem.dateRange = stringDate;
    }

    private dateFormat(classes: any, date: any) {
        if (!classes.disabled) {
            const a = moment(date.getTime()).format('DD MMM YYYY');
            const b = new Date();
            classes.disabled = moment(a).isAfter(b);
        }
        return classes;
    }

    private searchTable(searchText: any, searchKey: any) {
        const that = this;
        if (searchText.length >= 3 || isEmptyValue(searchText)) {
            switch (searchKey) {
                case 'title':
                    this.searchTerms.search_class_title = searchText;
                    break;
                case 'schoolName':
                    this.searchTerms.search_group_name = searchText;
                    break;
                case 'code':
                    this.searchTerms.search_class_code = searchText;
                    break;
                default:
                    break;
            }
            if (!that.isSearched) {
                that.isSearched = true;
                setTimeout(() => {
                    that.isSearched = false;
                    that.onSearch();
                }, 1000);
            }
        }
    }

    private removeDate(searchText: any, searchKey: any) {
        const that = this;
        switch (searchKey) {
            case 'title':
                this.searchTerms.search_class_title = '';
                this.searchItem.title = '';
                break;
            case 'schoolName':
                this.searchTerms.search_group_name = '';
                this.searchItem.schoolName = '';
                break;
            case 'code':
                this.searchTerms.search_class_code = '';
                this.searchItem.code = '';
                break;
            default:
                break;
        }
        that.onSearch();
    }

    private onArchiveOne(listItem: any) {
        this.isArchiveSuccessfully = false;
        this.selectedArchive = [];
        this.selectedArchiveList = [];
        this.archiveListModal = listItem;
        this.$bvModal.show('archive-confirm');
        this.selectedArchive = [listItem.id];
    }


    private async archiveClasses() {
        const that = this;
        const parmas = {
            class_ids: this.selectedArchive,
            is_archived: true,
        };
        adminUtilsAPI.archiveMultipleClasses(parmas).then((data: any) => {
            if (!isAPICatchError(data)) {
                this.isArchiveSuccessfully = true;
                setTimeout(() => {
                    that.$bvModal.hide('archive-confirm');
                    if (this.archiveListModal && this.archiveListModal.title) {
                        this.archiveListModal.isArchived = true;
                    } else {
                        setTimeout(() => {
                            this.classesList = [];
                            this.selectedArchiveList = [];
                            this.selectedArchive = [];
                            this.getClassList();
                        }, 1000);
                    }
                }, 1000);
            }
        });
    }

    private toggleSelectAll() {
        this.isSelectAll = !this.isSelectAll;
        if (this.isSelectAll) {
            this.selectAll();
        } else {
            this.removeAll();
        }
    }

    private selectAll() {
        this.isSelectAll = true;
        for (const listItem of this.classesList) {
            if (listItem.isArchived) {
                continue;
            }
            const selectedIndex = this.selectedArchiveList.
            findIndex((item: any) => item.id === listItem.id && !listItem.isArchived);
            if (selectedIndex === -1) {
                this.selectedArchiveList.push(listItem);
            }
            this.selectedArchive = this.selectedArchiveList.map((items: any) => {
                return items.id;
            });
        }
    }

    private removeAll() {
        for (const listItem of this.classesList) {
            const selectedIndex = this.selectedArchiveList.findIndex((item: any) => item.id === listItem.id);
            if (selectedIndex !== -1) {
                this.selectedArchiveList.splice(selectedIndex, 1);
            }
            this.selectedArchive = this.selectedArchiveList.map((items: any) => {
                return items.id;
            });
        }
    }

    private hideConfirmationModal() {
        this.$bvModal.hide('archive-confirm');
        this.archiveListModal = {};
        this.selectedArchive = [];
        this.selectedArchiveList = [];
    }

    private showConfirmationModal() {
        if (this.selectedArchive && this.selectedArchive.length > 0) {
            this.isArchiveSuccessfully = false;
            if (this.selectedArchive.length === 1) {
                this.archiveListModal = this.selectedArchiveList[0];
            } else {
                this.archiveListModal = {};
            }
            this.$bvModal.show('archive-confirm');
        }
    }
}
